import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./pageHeader.html";
class PageHeader extends LightningElement {
  constructor(...args) {
    super(...args);
    // @api viewOption;
    /* handleViewOption = (event) => {
        if (event !== undefined && event.detail !== undefined && event.detail.checked) {
            this.viewOption = 'DataTable';
        } else {
            this.viewOption = 'TreeGrid';
        }
        const selectedViewEvent = new CustomEvent("selectedview", {
            detail: this.viewOption
          });
        this.dispatchEvent(selectedViewEvent);
    } */
    this.handleViewAs = event => {
      if (event !== undefined && event.currentTarget !== undefined && event.currentTarget.title === 'Data Table') {
        this.viewOption = 'DataTable';
        this.template.querySelector('img[data-my-id="dataTableView"]').style.boxShadow = 'rgb(195 195 195) 0px 0px 12px';
        this.template.querySelector('img[data-my-id="treeGridView"]').style.boxShadow = 'none';
      } else {
        this.viewOption = 'TreeGrid';
        this.template.querySelector('img[data-my-id="treeGridView"]').style.boxShadow = 'rgb(195 195 195) 0px 0px 12px';
        this.template.querySelector('img[data-my-id="dataTableView"]').style.boxShadow = 'none';
      }
      const selectedViewEvent = new CustomEvent('selectedview', {
        detail: this.viewOption
      });
      this.dispatchEvent(selectedViewEvent);
    };
  }
}
_registerDecorators(PageHeader, {
  fields: ["handleViewAs"]
});
export default _registerComponent(PageHeader, {
  tmpl: _tmpl
});